<template>
  <div class="collection">
    <div class="PageHeader">
      <el-breadcrumb>
        <el-breadcrumb-item>{{ l("我的客户") }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="PageContent">
      <template v-if="$store.state.session.host_token_admin==2">
        <h2>业务员模拟登录状态不显示客户信息</h2>
      </template>
      <template v-else>
        <el-tabs type="border-card" v-model="activeName">
          <el-tab-pane :label="l('采购商')" name="purchaser">
            <el-table :data="TableList" :stripe="true" @selection-change="HandleSelectionChange"
              @sort-change="HandleSortChange">
              <el-table-column :label="l('标题')" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="color-link" @click="goItem(scope.row)" style="cursor: pointer;">{{ scope.row.purchase.title }}</span>
                </template>
              </el-table-column>

              <el-table-column :label="l('类型')">
                <template slot-scope="scope">
                  <span v-if="scope.row.purchase.quality_type == 1">{{ l("原料求购") }}</span>
                  <span v-else-if="scope.row.purchase.quality_type == 2">{{ l("零切交易") }}</span>
                  <span v-else-if="scope.row.purchase.quality_type == 3">{{ l("锻件定制") }}</span>
                  <span v-else-if="scope.row.purchase.quality_type == 4">{{ l("机加工") }}</span>
                </template>
              </el-table-column>

              <el-table-column :label="l('企业名称')" show-overflow-tooltip>

                <template slot-scope="scope">
                  {{ scope.row.target_user.tenant ? scope.row.target_user.tenant.name :
                    scope.row.target_user.pre_company_name }}
                </template>

              </el-table-column>

              <el-table-column :label="l('信用等级')" width="110">
                <template slot-scope="scope">
                  <div style="display: flex;">
                    <div v-for="(item, index) in 5" :key="index">
                      <el-image v-if="scope.row.target_user.tenant && index < scope.row.target_user.tenant.credit_rating"
                        style="width:18px; height:18px" :src="GetResourceUrl('backend/icon-star.svg')"></el-image>
                      <el-image v-else style="width:18px; height:18px"
                        :src="GetResourceUrl('backend/icon-star-un.svg')"></el-image>
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="target_user.mobile" :label="l('联系方式')" show-overflow-tooltip></el-table-column>

              <el-table-column prop="created_time" :label="l('国家/地区')" width="120">
                <template slot-scope="scope">
                  <img :src="GetResourceUrl('flags/' + scope.row.target_user.country.toLowerCase() + '.png')"
                    style="width:20px;" />
                </template>
              </el-table-column>

              <el-table-column prop="created_time" :label="l('获取日期')" sortable="custom" width="150">
                <template slot-scope="scope">
                  {{ scope.row.created_time.slice(0, 10) }}
                </template>
              </el-table-column>
            </el-table>
            <el-pagination background @size-change="HandleSizeChange" @current-change="HandleCurrentChange"
              :current-page="CurrentPage" :page-sizes="PageSizeList" :page-size="PageSize"
              layout="total, prev, pager, next, jumper" :total="TotalCount"></el-pagination>


          </el-tab-pane>
          <el-tab-pane :label="l('供应商')" name="supplier">

            <el-table :data="TableList" :stripe="true" @selection-change="HandleSelectionChange"
              @sort-change="HandleSortChange">
              <el-table-column :label="l('标题')" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="color-link" @click="goItem(scope.row)" style="cursor: pointer;">{{ scope.row.purchase.title }}</span>
                </template>
              </el-table-column>

              <el-table-column :label="l('类型')">
                <template slot-scope="scope">
                  <span v-if="scope.row.purchase.quality_type == 1">{{ l("原料求购") }}</span>
                  <span v-else-if="scope.row.purchase.quality_type == 2">{{ l("零切交易") }}</span>
                  <span v-else-if="scope.row.purchase.quality_type == 3">{{ l("锻件定制") }}</span>
                  <span v-else-if="scope.row.purchase.quality_type == 4">{{ l("机加工") }}</span>
                </template>
              </el-table-column>

              <el-table-column :label="l('企业名称')" show-overflow-tooltip>

                <template slot-scope="scope">
                  {{ scope.row.target_user.tenant ? scope.row.target_user.tenant.name :
                    scope.row.target_user.pre_company_name }}
                </template>

              </el-table-column>

              <el-table-column :label="l('信用等级')" width="110">
                <template slot-scope="scope">
                  <div style="display: flex;">
                    <div v-for="(item, index) in 5" :key="index">
                      <el-image v-if="scope.row.target_user.tenant && index < scope.row.target_user.tenant.credit_rating"
                        style="width:18px; height:18px" :src="GetResourceUrl('backend/icon-star.svg')"></el-image>
                      <el-image v-else style="width:18px; height:18px"
                        :src="GetResourceUrl('backend/icon-star-un.svg')"></el-image>
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="target_user.mobile" :label="l('联系方式')" show-overflow-tooltip></el-table-column>

              <el-table-column prop="created_time" :label="l('国家/地区')" width="120">
                <template slot-scope="scope">
                  <img :src="GetResourceUrl('flags/' + scope.row.target_user.country.toLowerCase() + '.png')"
                    style="width:20px;" />
                </template>
              </el-table-column>

              <el-table-column prop="created_time" :label="l('获取日期')" sortable="custom" width="150">
                <template slot-scope="scope">
                  {{ scope.row.created_time.slice(0, 10) }}
                </template>
              </el-table-column>
            </el-table>
            <el-pagination background @size-change="HandleSizeChange" @current-change="HandleCurrentChange"
              :current-page="CurrentPage" :page-sizes="PageSizeList" :page-size="PageSize"
              layout="total, prev, pager, next, jumper" :total="TotalCount"></el-pagination>


          </el-tab-pane>
        </el-tabs>
      </template>

    </div>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";

export default {
  name: "Collection",
  mixins: [tableMixin],
  data() {
    return {
      SearchData: {
        module: "purchase",
      },
      PageSize: 10,
      activeName: "purchaser"//purchaser purchase_business_action
    };
  },
  watch: {
    activeName(newVal, oldVal) {
      if (newVal == "purchaser") {
        this.SearchData.module = "purchase";
      } else if (newVal == "supplier") {
        this.SearchData.module = "purchase_business_action";
      }
      this.GetTableList(true);
    },
  },
  mounted() { },
  methods: {
    GetTableList(resetPage) {
      if(this.$store.state.session.host_token_admin==2) return
      if (resetPage == true) this.CurrentPage = 1;
      this.axios
        .get("/api/visitor_purchase/unlock_business_list/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results;
        });
    },

    goItem(item) {
      if (item.purchase.quality_type == 1) {
        this.$openRouter({
          path: `/home/purchase_material/${item.purchase.code}`,
        });
      } 
      else if (item.purchase.quality_type == 2) {
        this.$openRouter({
          path: `/home/purchase_piece/${item.purchase.code}`,
        });
      }
      else if (item.purchase.quality_type == 3) {
        this.$openRouter({
          path: `/home/purchase_forging/${item.purchase.code}`,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
